import { BeneficiaryVAT, TBeneficiaryPrecount } from "store/types";

/**
 * Defines VAT + precount combinations that are fiscally unusual for a given country.
 * When a beneficiary matches a rule, a warning is shown in the profile form.
 *
 * To add rules for a new country: add an entry keyed by its 2-letter country code.
 * Each rule produces one warning message (i18n key).
 */
export type VatPrecountRule = {
    precountValues: TBeneficiaryPrecount[];
    vatValues: BeneficiaryVAT[];
    warningKey: string;
};

export const VAT_PRECOUNT_RULES: Record<string, VatPrecountRule[]> = {
    GR: [
        {
            // Professional author (PRECOUNTED) should normally issue a VAT invoice
            precountValues: [TBeneficiaryPrecount.PRECOUNTED],
            vatValues: [BeneficiaryVAT.NONE],
            warningKey: "Beneficiars.Greece.Warning.ProfessionalWithoutVAT",
        },
        {
            // Standard author (CONDITIONAL / ESD) does not issue a VAT invoice
            precountValues: [TBeneficiaryPrecount.CONDITIONAL],
            vatValues: [BeneficiaryVAT.VAT],
            warningKey: "Beneficiars.Greece.Warning.StandardWithVAT",
        },
    ],
};
